import {
    MMSI_NO_VERIFICATION,
    OTHER_DETAILS,
    STATION_INFORMATION,
    SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyLicence/SSLLicence';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';
import { formatDateTo_ddMMyyyy } from 'utils/application.helpers';

export const formatSSL = async (licenceDetails: any, caseTypeID: string, application?: string) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    licence = {
        id: 'ship-station',
        formID: 'ship-station',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${MMSI_NO_VERIFICATION}-call-sign`]: licenceDetails?.mmsiNoDscSsiEpirbVerification?.callSign ?? '-',
            [`${MMSI_NO_VERIFICATION}-telex-over-radio-no`]: licenceDetails?.mmsiNoDscSsiEpirbVerification?.telexOverRadioTorNo ?? '-',
            [`${MMSI_NO_VERIFICATION}-mmsi-no`]: licenceDetails?.mmsiNoDscSsiEpirbVerification?.mmsiNoDscSsiEpirb ?? '-',
            [`${MMSI_NO_VERIFICATION}-mmsi-expiry-date`]: formatDateTo_ddMMyyyy(licenceDetails?.mmsiNoDscSsiEpirbVerification?.mmsiExpiryDate) ?? '-',

            [`${STATION_INFORMATION}-vessel-name`]: licenceDetails?.stationInformation?.vesselName ?? '-',
            [`${STATION_INFORMATION}-area-of-operation`]: licenceDetails?.stationInformation?.areaOfOperation ?? '-',
            [`${STATION_INFORMATION}-vessel-gross-tonnage`]: licenceDetails?.stationInformation?.vesselGrossTonnage ?? '-',
            [`${STATION_INFORMATION}-month-year-built`]: licenceDetails?.stationInformation?.monthYearBuilt ?? '-',
            [`${STATION_INFORMATION}-itu-nature-of-service`]: licenceDetails?.stationInformation?.ituNatureOfService ?? '-',
            [`${STATION_INFORMATION}-accounting-authority`]: licenceDetails?.stationInformation?.accountingAuthority ?? '-',
            [`${STATION_INFORMATION}-station-information-remarks`]: licenceDetails?.stationInformation?.remarks ?? '-',
            [`${STATION_INFORMATION}-inmarsat-id-c`]: licenceDetails?.stationInformation?.inmarsatIdC ?? '-',
            [`${STATION_INFORMATION}-other-id-line-1`]: licenceDetails?.stationInformation?.otherIdLine1 ?? '-',
            [`${STATION_INFORMATION}-other-id-line-2`]: licenceDetails?.stationInformation?.otherIdLine2 ?? '-',
            [`${STATION_INFORMATION}-other-id-line-3`]: licenceDetails?.stationInformation?.otherIdLine3 ?? '-',
            [`${STATION_INFORMATION}-other-id-line-4`]: licenceDetails?.stationInformation?.otherIdLine4 ?? '-',
            [`${STATION_INFORMATION}-official-no`]: licenceDetails?.stationInformation?.officialNo ?? '-',
            [`${STATION_INFORMATION}-vessel-type`]: licenceDetails?.stationInformation?.vesselType ?? '-',
            [`${STATION_INFORMATION}-satellite-service`]: licenceDetails?.stationInformation?.satelliteService ?? '-',
            [`${STATION_INFORMATION}-purposes`]: licenceDetails?.stationInformation?.purposes ?? '-',
            [`${STATION_INFORMATION}-brand-and-model`]: licenceDetails?.stationInformation?.brandAndModel ?? '-',
            [`${STATION_INFORMATION}-hours-of-service`]: licenceDetails?.stationInformation?.hoursOfService ?? '-',
            [`${STATION_INFORMATION}-start-time`]: licenceDetails?.stationInformation?.startTime ?? '-',
            [`${STATION_INFORMATION}-end-time`]: licenceDetails?.stationInformation?.endTime ?? '-',

            [`${OTHER_DETAILS}-proposed-use-of-system`]: licenceDetails?.otherDetails?.proposedUseOfSystem ?? '-',
            [`${OTHER_DETAILS}-remarks`]: licenceDetails?.otherDetails?.remarks ?? '-',

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    return licence;
};

const sslPayload = {
    formatSSL
};

export default sslPayload;
